<template>
  <a-drawer
    title="操作"
    :width="720"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
  >
    <a-form :form="form">
      <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="[
            'name',
            {
              rules: [{ required: true, message: '请填写姓名' }]
            }
          ]"
          placeholder="请输入姓名"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="登录账号"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'loginName',
            {
              rules: [{ required: true, message: '请填写登录账号' }]
            }
          ]"
          placeholder="请输入登录账号"
        ></a-input>
      </a-form-item>
      <a-form-item label="工号" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="[
            'empCode',
            {
              rules: [{ required: true, message: '请填写工号' }]
            }
          ]"
          placeholder="请输入工号"
        ></a-input>
      </a-form-item>
      <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-tree-select
          v-decorator="[
            'deptId',
            { rules: [{ required: true, message: '请选择部门' }] }
          ]"
          :replaceFields="{
            title: 'title',
            key: 'key',
            value: 'key',
            children: 'children'
          }"
          style="width:100%"
          :treeData="depts"
          @change="deptChange"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item
        label="手机号码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['mobile']"
          placeholder="请输入手机号码"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="角色分配"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="['userRoleIdsList']"
          mode="multiple"
          style="width:100%"
          placeholder="请选择角色"
          :options="roles"
        >
        </a-select>
      </a-form-item>
      <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-radio-group v-decorator="['sex', { initialValue: 'M' }]">
          <a-radio value="M">男</a-radio>
          <a-radio value="W">女</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="用户状态"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          style="width:100%"
          placeholder="请选择"
          v-decorator="['status', { initialValue: 'A' }]"
        >
          <a-select-option key="A" value="A">正常</a-select-option>
          <a-select-option key="D" value="D">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <!-- <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <j-image-upload
          class="avatar-uploader"
          text="上传"
          @change="uploadImg"
          v-model="fileList"
        ></j-image-upload>
      </a-form-item> -->
      <!-- 保存、取消 -->
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '.8rem' }" @click="onClose">
          取消
        </a-button>
        <a-button :loading="loading" type="primary" @click="editSubmit">
          保存
        </a-button>
      </div>
    </a-form>
  </a-drawer>
</template>

<script>
// import JImageUpload from "@components/JImageUpload/JImageUpload";
import { save } from "@/api/system/user";
import { findAll } from "@/api/system/role";
import { findAllDepts } from "@/api/system/dept";

import pick from "lodash/pick";

export default {
  name: "UserDrawer",
  components: {
    // JImageUpload
  },
  data() {
    return {
      //表单配置start
      visible: false,
      form: this.$form.createForm(this),
      loading: false,
      labelCol: { lg: { span: 5 }, sm: { span: 7 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 17 } },
      //表单配置end
      user: {},
      depts: [], //部门树
      roles: [], //角色列表
      fileList: "" //头像
    };
  },
  created() {
    findAllDepts().then(res => {
      this.depts = res.result;
    });
    findAll().then(res => {
      this.roles = res.map(item => {
        return { value: item.id, label: item.roleName };
      });
    });
  },
  methods: {
    deptChange(val, label) {
      this.user.deptName = label.toString();
    },
    edit(record) {
      this.visible = true;
      if (record) {
        console.log(record);
        this.user = Object.assign({}, record);
        this.$nextTick(() => {
          let FieldsVal = pick(
            record,
            "name",
            "loginName",
            "empCode",
            "deptId",
            "mobile",
            "userRoleIdsList",
            "sex",
            "status"
          );
          this.form.setFieldsValue(FieldsVal);
        });
      }
    },
    onClose() {
      this.form.resetFields();
      this.visible = false;
    },
    uploadImg(path) {
      this.fileList = path;
    },
    editSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          let params = Object.assign(this.user, values);
          if (params.userRoleIdsList) {
            params.userRoles = params.userRoleIdsList.toString();
          }
          params.avatar = this.fileList;
          save({ ...params }).then(res => {
            this.$notification.success({
              message: res.message
            });
            this.loading = false;
            this.onClose();
            this.$emit("ok");
          });
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
</style>
